import * as React from 'react';
import { withRouter } from 'react-router';

import Knob from 'components/atoms/Knob';
import Bevel from 'components/helper/Bevel';
import PoolTabNavigation from 'components/molecules/PoolTabNavigation';
import TagFilterPool from 'containers/molecules/TagFilter/TagFilterPool';
import routes from 'defs/routes';
import { generateClassNameString } from 'helper/css';
import i18n from 'helper/i18n';
import { PoolClusterType, PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';
import { WithRouterType } from 'types/withRouter';

export type PoolPropsType = {
	title: string;
	modifier?: string | string[];
	selectedPool: PoolEnumType;
	selectedCluster: PoolClusterType;
	children?: React.ReactNode;
	hideFilters?: boolean;
} & WithRouterType;

export const Pool = ({
	title,
	selectedPool,
	selectedCluster,
	modifier,
	history,
	children,
	hideFilters = false,
}: PoolPropsType) => (
	<div className={generateClassNameString('o-pool', modifier)}>
		<div className="o-pool__head">
			<div className="container">
				<div className="o-pool__bar">
					<div className="o-pool__back">
						<Knob
							modifier="filled"
							size="s"
							icon="back"
							onClick={() => history.push(routes.today.indexRoute.href)}
						/>
					</div>
					<h1 className="o-pool__title">{title}</h1>
				</div>
				<div className="row">
					<div className="col-xs-12">
						<div className="o-pool__filter">
							<PoolTabNavigation selectedPool={selectedPool} selectedCluster={selectedCluster} />
						</div>
						{!hideFilters && (
							<div className="o-pool__tag-filter">
								<TagFilterPool
									selectedPool={selectedPool}
									selectedCluster={selectedCluster}
									description={i18n(
										`react.impulsCoach.views.pools.${selectedPool}.tagFilterDescription`
									)}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
			<Bevel modifier="bottom-left" color="ffffff" />
		</div>
		<div className="o-pool__content">{children}</div>
	</div>
);

export default withRouter(Pool as any) as React.ComponentType<Partial<PoolPropsType>>;
